import React from "react";
import { ReactComponent as MarkerIcon } from "Assets/icon/icon-marker.svg";

import styles from "./score-slider.module.scss";

interface ScoreSliderProps {
  value: number;
  barColor: string;
  textColor: string;
  showScore?: boolean;
  showMarker?: boolean;
  className?: string;
}

const ScoreSlider: React.FC<ScoreSliderProps> = ({
  value,
  barColor,
  textColor,
  showMarker = true,
  showScore = false,
}) => {
  const percentage = Math.min(Math.max(value, 0), 100);

  return (
    <div className={styles.container} data-testid="score-slider">
      {/* Score value and marker positioned together */}
      {showMarker && (
        <div
          className={styles["marker-container"]}
          style={{ left: `${percentage}%` }}
          data-testid="marker-container"
        >
          {showScore && (
            <div
              className={styles["score-value"]}
              style={{ color: textColor }}
              data-testid="score-value"
            >
              {value}
            </div>
          )}
          <MarkerIcon
            className={styles.marker}
            width={24}
            height={24}
            data-testid="marker-icon"
          />
        </div>
      )}

      {/* Progress bar */}
      <div
        className={styles.bar}
        style={{ backgroundColor: barColor }}
        data-testid="progress-bar"
      />

      {/* Min/Max labels */}
      <div className={styles.labels}>
        <span className={styles.label} style={{ color: textColor }}>
          0
        </span>
        <span className={styles.label} style={{ color: textColor }}>
          100
        </span>
      </div>
    </div>
  );
};

export default ScoreSlider;
